module.exports = __webpack_public_path__ + "img/close.22855fc5.svg";